import { render, staticRenderFns } from "./LanguageSwitch.vue?vue&type=template&id=00d29c70&scoped=true"
import script from "./LanguageSwitch.js?vue&type=script&lang=js&external"
export * from "./LanguageSwitch.js?vue&type=script&lang=js&external"
import style0 from "./LanguageSwitch.scss?vue&type=style&index=0&id=00d29c70&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d29c70",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotIcon: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Icon/Icon.vue').default})
